import {
    Button, Dialog, DialogActions, DialogContent,
    DialogTitle, useMediaQuery, useTheme, Grid, RadioGroup
} from "@material-ui/core";
import React, { useCallback, useContext, useState, useEffect } from 'react'
import { MTable } from "../../../../../Components";
import { useAptorApi } from "../../../../../Api";
import { useIntl } from "react-intl";
import { AccessLevel, LawPortalFeature, UserContext } from "../../../../../Context/UserContext/UserContext";
import moment from "moment";
import { Query } from "@material-table/core";
import { IGridQueryRequest, OrderDirection } from "../../../../../Api/AptorApi";
import { TextField, DateField } from "../../../../../Components/Field";
import { ComplianceReportCheckbox } from "../../../Components/Compliance/Checkbox";
import { SelectOption, TypedFormFieldValue } from "../../../../../Components/Form/Form.types";
interface Iprops {
    open: boolean
    setOpen: (val: boolean) => void;
    rowData: any
    onSaveSuccess?: () => void;
}
const EditObservationModal = ({ open, setOpen, rowData, onSaveSuccess }: Iprops) => {
    const { api } = useAptorApi();
    const { formatMessage } = useIntl();
    const theme = useTheme();
    const fullScreen = useMediaQuery((theme) => (theme as any).breakpoints.down('md'));
    
    // Form state
    const [compliance, setCompliance] = useState<'yes' | 'no' | 'deficiency'>('yes');
    const [answer, setAnswer] = useState<TypedFormFieldValue<string>>();
    const [deadline, setDeadline] = useState<TypedFormFieldValue<Date>>();

    // Initialize form with rowData
    useEffect(() => {
        if (rowData && open) {
            setCompliance(rowData?.compliance || '');
            setAnswer({ value: rowData?.answer || '' });
            setDeadline(rowData?.deadline ? { value: moment(rowData.deadline).toDate() } : undefined);
        }
    }, [rowData, open]);

    const handleClose = () => {
        setOpen(false)
    };

    const handleSave = async () => {
        try {
            // TODO: Add API call to save observation
            // const response = await api.updateObservation({
            //     id: rowData?.id,
            //     compliance,
            //     answer: answer?.value,
            //     deadline: deadline?.value
            // });
            
            onSaveSuccess?.();
            setOpen(false);
        } catch (error) {
            console.error('Error saving observation:', error);
        }
    };



    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            maxWidth="sm" 
            fullWidth
        >
            <DialogTitle id="responsive-dialog-title">
                {formatMessage({ id: "law-portal.our-laws.table-row.popup.title", defaultMessage: "Evaluation Compliance" })}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} style={{ marginTop: '10px' }}>
                    {/* Compliance Status */}
                    <Grid item xs={12}>
                        <label style={{ fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
                            {formatMessage({ id: 'law-portal.compliance.report.table.col' })}
                        </label>
                        <RadioGroup row onChange={(e) => setCompliance(e.target.value as 'yes' | 'no' | 'deficiency')}>
                            <ComplianceReportCheckbox 
                                type="deficiency" 
                                value={compliance} 
                                hidden={false} 
                            />
                            <ComplianceReportCheckbox 
                                type="no" 
                                value={compliance} 
                                hidden={false} 
                            />
                            <ComplianceReportCheckbox 
                                type="yes" 
                                value={compliance} 
                                hidden={false} 
                            />
                        </RadioGroup>
                    </Grid>

                    {/* Answer Field */}
                    <Grid item xs={12}>
                        <TextField
                            name="answer"
                            label={formatMessage({ id: 'law-portal.legal.compliance.sub-menu.reports.observations' })}
                            rows={4}
                            multiline
                            errorTexts={[]}
                            initialState={answer}
                            onChange={setAnswer}
                        />
                    </Grid>

                    {/* Deadline Date Field */}
                    <Grid item xs={12}>
                        <DateField
                            name="deadline"
                            label={formatMessage({ id: 'law-portal.compliance.form.date.label' })}
                            errorTexts={[]}
                            initialState={deadline}
                            onChange={setDeadline}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button style={{ marginTop: '25px', marginBottom: "10px" }} variant="outlined" onClick={handleClose}>
                    {formatMessage({ id: 'form.cancel' })}
                </Button>
                <Button style={{ marginTop: '25px', marginRight: '42px', marginBottom: "10px" }} variant="outlined" onClick={handleSave} >
                    {formatMessage({ id: 'form.save' })}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default EditObservationModal